import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-add-new-bank-account-action',
  templateUrl: './add-new-bank-account-action.component.html',
  styleUrl: './add-new-bank-account-action.component.scss'
})
export class AddNewBankAccountActionComponent {
  @Input() addOrEditBankAccount: () => void = () => {};
  @Input() label: string = 'Bank account';
}
